export default __webpack_public_path__ + "assets/images/e634dd5229fe41865ccbff56bd407f90.png";